import React, { useEffect, useState, useContext } from 'react';
import {
  Box, Typography, TextField, Checkbox, FormControlLabel,
  Button, Container, Paper, useMediaQuery, useTheme, IconButton
} from '@mui/material';
import { useNavigate, useLocation } from 'react-router-dom';
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';
import { Link } from 'react-router-dom';
import FormsBottomNavbar from './../Post Module/FormsBottomNavbar';
import property_pincode_new from './../../../Images/property_pincode_new.png';
import axios from 'axios';
import { AuthContext } from './../../AuthContext/AuthContext';
import { BASE_URL } from './../../Api/ApiUrls';
import SuccessAlert from '../../../Components/Users/Alertpage/SuccessAlert/SuccessAlert';
import FailureAlert from '../../../Components/Users/Alertpage/FailureAlert/FailureAlert';

function InteriorConsultationForm() {
  const { userId, logout } = useContext(AuthContext);
  const navigate = useNavigate();
  const theme = useTheme();
   const location = useLocation();
     const [showSuccess, setShowSuccess] = useState(false);
     const [showFailure, setShowFailure] = useState(false);
     const [alertMessage, setAlertMessage] = useState("");
   
  const isMobile = useMediaQuery(theme.breakpoints.down('sm'));
  const [formData, setFormData] = useState({
    name: '',
    email: '',
    phone: '',
  });

  // Replace with dynamic value (e.g. from localStorage or props)

  // Fetch user data
  useEffect(() => {
    axios.get(`${BASE_URL}/users/`)
      .then(response => {
        const matchedUser = response.data.find(user => user.user_id == userId);
        if (matchedUser) {
          setFormData({
            name: `${matchedUser.first_name} ${matchedUser.last_name}`,
            email: matchedUser.email,
            phone: matchedUser.mobile_no,
          });
        }
      })
      .catch(error => {
        console.error("Error fetching user data:", error);
      });
  }, [userId]);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData(prev => ({
      ...prev,
      [name]: value,
    }));
  };
const handleSubmit = (e) => {
  e.preventDefault();

  axios.post(`${BASE_URL}/consultant-req/`, {
    user_id: userId,
    interested_on: "Interior"
  })
  .then((response) => {
    if (response) {
      setAlertMessage("Consultation request submitted successfully!");
      setShowSuccess(true);
    } else {
      setAlertMessage("Something went wrong. Try again.");
      setShowFailure(true);
    }
  })
  .catch((error) => {
    console.error("Submission error:", error);

    setAlertMessage(
      error.response?.data?.message || "Failed to submit request."
    );
    setShowFailure(true);
  });
};

  return (
    <Box sx={{ display: 'flex', flexDirection: 'column', height: '100vh', overflow: 'hidden' }}>
      {/* Fixed Header Section */}
      <Box sx={{ flexShrink: 0 }}>
        {/* Header */}
        <Box sx={{ position: 'sticky', top: 0, zIndex: 1200, bgcolor: 'background.paper', boxShadow: '0 2px 4px rgba(0,0,0,0.1)' }}>
          <Box display="flex" alignItems="center" justifyContent="space-between" p={1} sx={{ background: 'black', borderBottom: '1px solid rgba(0,0,0,0.08)' }}>
            <IconButton onClick={() => navigate(-1)} sx={{ color: 'white' }}>
              <ArrowBackIosIcon />
            </IconButton>
            <Typography variant="h7" sx={{ color: 'white', fontWeight: 'bold', textAlign: 'left' }}>PROPERTY PINCODER</Typography>
            <Box sx={{ width: 100, height: 50, display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
              <img src={property_pincode_new} alt="property_pincode_new Logo" style={{ maxWidth: '100%', maxHeight: '100%', boxShadow: '0px 4px 10px rgba(255, 255, 255, 0.6)', objectFit: 'contain' }} />
            </Box>
          </Box>
        </Box>
        <Box sx={{
               padding: isMobile ? 1 : 0.5,
               display: 'flex',
               justifyContent: 'space-between',
               boxShadow: '0 5px 10px rgba(0,0,0,0.1)',
             }}>
               {/* Constructions - Inactive (Dark) */}
               <Box
                 component={Link}
                 to="/constructions"
                 sx={{
                   flex: 1,
                   textAlign: 'center',
                   py: 2,
                   textDecoration: 'none',
                   position: 'relative',
                   background: `
                     linear-gradient(145deg, rgb(22, 22, 22), rgb(15, 15, 15)),
                     url('/construction5.png')
                   `,
                   backgroundBlendMode: 'overlay',
                   borderRight: '1px solid rgba(0,0,0,0.1)',
                   borderTopLeftRadius: '30px',
                   boxShadow: `
                     inset 0 0 15px rgba(0,0,0,0.2),
                     0 2px 5px rgba(0,0,0,0.1)
                   `,
                   transform: 'scale(0.98)',
                   transition: 'all 0.3s ease',
                   '&:hover': {
                     background: `
                       linear-gradient(145deg, rgb(35, 35, 35), rgb(25, 25, 25)),
                       url('/construction5.png')
                     `,
                     transform: 'scale(1)',
                     boxShadow: `
                       inset 0 0 20px rgba(0,0,0,0.3),
                       0 3px 8px rgba(0,0,0,0.2)
                     `,
                   },
                   '&::after': {
                     content: '""',
                     position: 'absolute',
                     bottom: 0,
                     left: '50%',
                     transform: 'translateX(-50%)',
                     width: '0%',
                     height: '3px',
                     backgroundColor: 'transparent',
                     borderRadius: '3px',
                     transition: 'all 0.3s ease',
                   }
                 }}>
                 <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
                   fontWeight: 700,
                   color: 'rgba(255,255,255,0.9)',
                   textShadow: '0 1px 5px rgba(0,0,0,0.7)',
                   fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
                   transform: 'scale(1)',
                   transition: 'transform 0.3s ease',
                 }}>
                   Constructions
                 </Typography>
               </Box>
             
               {/* Interiors - Active (Light) */}
               <Box
                 component={Link}
                 to="/interiors"
                 sx={{
                   flex: 1,
                   textAlign: 'center',
                   py: 2,
                   position: 'relative',
                   background: `
                     linear-gradient(145deg, rgba(232,224,208,0.95), rgba(216,204,186,0.95)),
                     url('/construction4.png')
                   `,
                   backgroundBlendMode: 'overlay',
                   textDecoration: 'none',
                   borderBottomRightRadius: '30px',
                   boxShadow: `
                     inset 0 0 15px rgba(0,0,0,0.2),
                     0 4px 10px rgba(0,0,0,0.15)
                   `,
                   transform: 'scale(1.02)',
                   transition: 'all 0.3s ease',
                   zIndex: 1,
                   '&:hover': {
                     transform: 'scale(1.05)',
                     boxShadow: `
                       inset 0 0 20px rgba(0,0,0,0.15),
                       0 5px 12px rgba(0,0,0,0.18)
                     `,
                     '&::after': {
                       width: '70%',
                       backgroundColor: '#333333',
                     }
                   },
                   '&::after': {
                     content: '""',
                     position: 'absolute',
                     bottom: 0,
                     left: '50%',
                     transform: 'translateX(-50%)',
                     width: '70%',
                     height: '3px',
                     backgroundColor: '#333333',
                     borderRadius: '3px',
                     transition: 'all 0.3s ease',
                   }
                 }}
               >
                 <Typography variant={isMobile ? "h6" : "h5"} component="div" sx={{
                   fontWeight: 800,
                   color: '#333333',
                   letterSpacing: '1px',
                   textShadow: '0 1px 3px rgba(255,255,255,0.5)',
                   fontFamily: 'Inter, Roboto, Helvetica, sans-serif',
                   transform: 'scale(1.05)',
                   transition: 'transform 0.3s ease',
                 }}>
                   Interiors
                 </Typography>
               </Box>
             </Box>
      </Box>

      {/* Scrollable Body Section */}
      <Box sx={{ 
        flex: 1, 
        overflowY: 'auto',
        backgroundColor: "#e7dbc9"
      }}>
        {/* Main Form */}
        <Box sx={{ backgroundColor: "#e7dbc9", minHeight: '100%' }}>
          <Container maxWidth="sm" sx={{ pt: 4, pb: 12 }}>
            <Paper elevation={3} sx={{ p: { xs: 2, sm: 4 } }}>
              <Typography variant={isMobile ? 'h6' : 'h5'} sx={{ fontWeight: 600, textAlign: 'center', mb: 3 }}>
                Talk to an Interior Designer
              </Typography>

              <Box component="form" noValidate autoComplete="off" onSubmit={handleSubmit}>
                <TextField
                  fullWidth label="Name" margin="normal" size="small"
                  name="name" value={formData.name} onChange={handleChange}
                />
                <TextField
                  fullWidth label="Email ID" margin="normal" size="small"
                  name="email" value={formData.email} onChange={handleChange}
                />
                <TextField
                  fullWidth label="Phone" margin="normal" size="small"
                  name="phone" value={formData.phone} onChange={handleChange}
                />

                <FormControlLabel
                  control={<Checkbox defaultChecked color="primary" />}
                  label="Check Updates on Whatsapp"
                  sx={{ mb: 2 }}
                />

                <Box sx={{ textAlign: 'center' }}>
                  <Button
                    variant="contained" type="submit"
                    sx={{
                      backgroundColor: 'red', color: '#fff',
                      borderRadius: '20px', px: 4, py: 1, fontWeight: 'bold',
                      '&:hover': { backgroundColor: '#cc0000' },
                    }}
                  >
                    GET FREE CONSULTATION
                  </Button>
                </Box>
              </Box>
            </Paper>
          </Container>
        </Box>
      </Box>
   {showSuccess && (
        <SuccessAlert
          message={alertMessage}
          onClose={() => {
            setShowSuccess(false);
           
          }}
        />
      )}
      
      {showFailure && (
        <FailureAlert
          message={alertMessage}
          onClose={() => {
            console.log("Closing failure alert"); // Debug log
            setShowFailure(false);
            setAlertMessage(""); 
           
            navigate("/get-started");
          }}
        />
      )}
      {/* Fixed Bottom Navbar */}
      <Box sx={{ flexShrink: 0 }}>
        <FormsBottomNavbar />
      </Box>
    </Box>
  );
}

export default InteriorConsultationForm;
